import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
export const BookingCTA = () => {
  return <section id="contacto" className="py-24 md:py-32 bg-gradient-brand text-center px-6 relative overflow-hidden" data-id="element-30">
      {/* Decorative elements */}
      <div className="absolute top-0 left-1/4 w-64 h-64 bg-white/10 rounded-full blur-3xl" data-id="element-31"></div>
      <div className="absolute bottom-0 right-1/4 w-64 h-64 bg-brand-gold/20 rounded-full blur-3xl" data-id="element-32"></div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} className="max-w-3xl mx-auto relative z-10" data-id="element-33">
        <h2 className="text-4xl md:text-6xl font-heading font-bold text-white mb-6" data-id="element-34">
          ¿Lista para tu próxima cita?
        </h2>
        <p className="text-xl text-white/90 mb-12 font-medium" data-id="element-35">
          Reservá tu turno fácil y rápido por WhatsApp
        </p>

        <a href="#" className="inline-flex items-center gap-3 bg-white text-brand-magenta px-10 py-5 rounded-full text-xl font-bold hover:scale-105 transition-transform shadow-xl shadow-brand-dark/10" data-id="element-36">
          <MessageCircle size={28} data-id="element-37" />
          Reservar por WhatsApp
        </a>

        <p className="mt-6 text-white/80 text-sm font-medium flex items-center justify-center gap-2" data-id="element-38">
          Respondemos a la brevedad ✨
        </p>
      </motion.div>
    </section>;
};